import { render } from "./Question.vue?vue&type=template&id=07c4bcfa&scoped=true&ts=true"
import script from "./Question.vue?vue&type=script&lang=ts"
export * from "./Question.vue?vue&type=script&lang=ts"

import "./Question.vue?vue&type=style&index=0&id=07c4bcfa&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c4bcfa"]])

export default __exports__